// extracted by mini-css-extract-plugin
module.exports = {"container":"ImageHeaderLayout_container__pj29n"};